import classNames from 'classnames'
import { useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import P from 'components/typography/Paragraph'
import Tooltip from 'components/misc/Tooltip'
import Badge from 'components/misc/Badge'
import OpenerIcon from 'components/misc/OpenerIcon'
import { MODAL_FROM_CONTEXTS, toggleModal } from 'store/ui/actions'
import { toggleFilter } from 'store/report/actions'
import styles from './styles/FilterCard.css'

const TooltipHeader = ({ tooltipCopy, children }) => {
  if (tooltipCopy) {
    return (
      <Tooltip
        placement='top'
        content={tooltipCopy}
        refClassName={styles.tooltip}
      >
        {children}
        <i className={styles.icon} />
      </Tooltip>
    )
  }

  return children
}

export const FilterCard = ({ className = '', title, children, tooltipCopy = '', beta = false, collapsible = false }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  const metadata = useSelector(({ report }) => report?.metadata)
  const needsUpgrade = useSelector(({ ui }) => !!ui.user)
  const paywalled = location.pathname.includes('reports/') && !!metadata?.restrictedCitationCount

  const handleClick = useCallback(_ => {
    if (!paywalled) {
      return
    }

    dispatch(toggleFilter('showMobile', false))
    dispatch(toggleModal(needsUpgrade ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_FILTER))
  }, [paywalled])

  return (
    <div className={classNames(styles.filterCard, className)} onClick={handleClick}>
      <div
        className={classNames({
          [styles.noInput]: paywalled
        })}
      >
        <div
          className={styles.filterCardHeader}
          onClick={() => collapsible && setIsOpen(!isOpen)}
          role='button'
          tabIndex='0'
          aria-label={`Expand ${title}`}
        >
          <TooltipHeader tooltipCopy={tooltipCopy}>
            <P className={styles.header} bold>{title} {beta && <Badge>beta</Badge>}</P>
          </TooltipHeader>
          {collapsible && <OpenerIcon show={isOpen} />}
        </div>
        {collapsible ? isOpen && children : children}
      </div>
    </div>
  )
}

export default (FilterCard)
